var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      verticalAlign: "middle",
      marginLeft: 3
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11C4 7.13359 7.13359 4 11 4C14.8664 4 18 7.13359 18 11C18 14.8664 14.8664 18 11 18C7.13359 18 4 14.8664 4 11ZM13.3406 16.535C14.057 16.2329 14.701 15.7981 15.2533 15.2458C15.807 14.6934 16.2404 14.0495 16.5439 13.3331C16.857 12.5921 17.0156 11.8046 17.0156 10.9924C17.0156 10.1803 16.857 9.39283 16.5426 8.65045C16.2404 7.93404 15.8057 7.29009 15.2533 6.73775C14.6996 6.1854 14.057 5.752 13.3406 5.44849C12.5996 5.1354 11.8121 4.97681 11 4.97681C10.1879 4.97681 9.40039 5.1354 8.65801 5.44985C7.9416 5.752 7.29766 6.18677 6.74531 6.73911C6.19297 7.29283 5.75957 7.93541 5.45605 8.65181C5.14297 9.39283 4.98438 10.1803 4.98438 10.9924C4.98438 11.8046 5.14297 12.5921 5.45742 13.3344C5.75957 14.0508 6.19434 14.6948 6.74668 15.2471C7.30039 15.7995 7.94297 16.2329 8.65938 16.5364C9.40039 16.8495 10.1879 17.0081 11 17.0081C11.8121 17.0081 12.5996 16.8495 13.3406 16.535Z",
    fill: "black",
    fillOpacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.542 14.057H11.458V9.47151C11.458 9.21087 11.2532 9 11 9H10.542H9.77863C9.52545 9 9.32061 9.21087 9.32061 9.47151C9.32061 9.73215 9.52545 9.94303 9.77863 9.94303H10.542V14.057H9.45802C9.20483 14.057 9 14.2678 9 14.5285C9 14.7891 9.20483 15 9.45802 15H10.542H11.458H12.542C12.7952 15 13 14.7891 13 14.5285C13 14.2678 12.7952 14.057 12.542 14.057Z",
    fill: "black",
    fillOpacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1902 7.49219C10.1902 7.76402 10.4105 7.98438 10.6824 7.98438C10.9542 7.98438 11.1746 7.76402 11.1746 7.49219C11.1746 7.22036 10.9542 7 10.6824 7C10.4105 7 10.1902 7.22036 10.1902 7.49219V7.49219Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.d2f3c9b1.svg";
export { ForwardRef as ReactComponent };